import type { Messages } from './en.js'

// Draft translations for UI chrome, pending professional review in Tolgee.
export const vi: Messages = {
  'common.needHelp': 'Cần trợ giúp?',
  'common.continue': 'Tiếp tục',
  'common.back': 'Quay lại',

  'shell.cookiePolicy': 'Chính sách Cookie',
  'shell.privacyPolicy': 'Chính sách Bảo mật',
  'shell.cookiePreferences': 'Tùy chọn Cookie',
  'shell.language': 'Ngôn ngữ',

  'login.title': 'Đăng nhập',
  'login.subtitle': 'Sử dụng địa chỉ email trên tài khoản của bạn.',
  'login.forgot': 'Quên mật khẩu?',
  'login.createAccount': 'Tạo tài khoản',

  'forgot.title': 'Đặt lại mật khẩu',
  'forgot.subtitle': 'Chúng tôi sẽ gửi mã 6 chữ số đến email của bạn để đặt mật khẩu mới.',
  'forgot.newTitle': 'Chọn mật khẩu mới',
  'forgot.backToSignIn': 'Quay lại đăng nhập',

  'consent.message':
    'Chúng tôi sử dụng cookie để vận hành trang web này và, khi có sự đồng ý của bạn, để đo lường và cải thiện.',
  'consent.acceptAll': 'Chấp nhận tất cả',
  'consent.essentialOnly': 'Chỉ cần thiết',

  'common.email': 'Địa chỉ email',
  'common.password': 'Mật khẩu',
  'common.tryAgain': 'Thử lại',
  'err.tooManyAttempts': 'Quá nhiều lần thử',
  'err.checkFailed': 'Kiểm tra thất bại',
  'err.otpDeliveryFailed': 'Chúng tôi không thể gửi mã',
  'err.otpLocked': 'Nhập sai mã quá nhiều lần',
  'err.otpExpired': 'Mã này đã hết hạn',
  'err.countryNotPermitted': 'Không khả dụng ở quốc gia của bạn',
  'err.temporarilyUnavailable': 'Tạm thời không khả dụng',
  'err.checkAnswers': 'Kiểm tra câu trả lời của bạn',
  'err.somethingWrong': 'Đã xảy ra lỗi',

  'step.account': 'Tài khoản',
  'step.identity': 'Danh tính',
  'step.compliance': 'Tuân thủ',
  'step.finish': 'Hoàn tất',

  'account.emailTitle': 'Mở tài khoản của bạn',
  'account.emailSubtitle': 'Chúng tôi sẽ gửi mã 6 chữ số đến email để xác nhận địa chỉ của bạn.',
  'account.botFailedTitle': 'Kiểm tra bảo mật không tải được',
  'account.botFailedBody': 'Bạn vẫn có thể tiếp tục — chúng tôi sẽ xác nhận khi bạn gửi.',
  'account.send': 'Gửi mã',
  'account.sending': 'Đang gửi…',
  'account.haveAccount': 'Đã có tài khoản?',
  'account.login': 'Đăng nhập',
  'account.otpTitle': 'Nhập mã của bạn',
  'account.otpSentTo': 'Đã gửi đến {target}.',
  'account.otpTargetFallback': 'email của bạn',
  'account.escalated': 'Chúng tôi đã gửi một mã khác từ nhà cung cấp khác.',
  'account.startAgain': 'Bắt đầu lại',
  'account.checking': 'Đang kiểm tra…',
  'account.verify': 'Xác minh',
  'account.resend': 'Gửi lại mã',
  'account.tryAnotherWay': 'Tôi chưa nhận được — thử cách khác',
  'account.differentEmail': 'Dùng email khác',
  'account.profileTitle': 'Một vài thông tin',
  'account.profileSubtitle': 'Đây là bước cuối để thiết lập tài khoản.',
  'account.emailReadonlyHint': 'Đã xác nhận bằng mã bạn vừa nhập.',
  'account.country': 'Quốc gia cư trú',
  'account.countrySearch': 'Tìm quốc gia',
  'account.phone': 'Điện thoại',
  'account.consentBefore':
    'Tôi đồng ý cho việc thu thập và sử dụng thông tin cá nhân của tôi theo',
  'account.consentAfter': ', và tôi hiểu rằng tôi có thể được liên hệ về hồ sơ của mình.',
  'account.creating': 'Đang tạo…',
  'account.existsTitle': 'Bạn đã có tài khoản',
  'account.signInInstead': 'Đăng nhập ngay',

  'partner.add': 'Bạn có mã đối tác?',
  'partner.label': 'Mã đối tác / Link ID',
  'partner.confirm': 'Áp dụng mã',
  'partner.remove': 'Xóa',
  'partner.close': 'Đóng ô mã đối tác',
  'partner.referredBy': 'Được giới thiệu bởi',
  'partner.partnerId': 'Mã đối tác',
  'partner.country': 'Quốc gia',
  'partner.unavailable': 'Chúng tôi không kiểm tra được mã này. Vui lòng thử lại.',

  'identity.notReadyTitle': 'Hoàn tất tài khoản trước',
  'identity.backToStep1': 'Quay lại bước 1',
  'identity.title': 'Xác minh danh tính của bạn',
  'identity.subtitle':
    'Quy định yêu cầu chúng tôi xác nhận danh tính của bạn trước khi giao dịch. Việc này mất khoảng hai phút.',
  'identity.startFailedTitle': 'Không thể bắt đầu xác minh',
  'identity.step1': 'Chuẩn bị hộ chiếu, CMND/CCCD hoặc bằng lái xe.',
  'identity.step2': 'Bạn sẽ chụp ảnh giấy tờ, rồi chụp một ảnh selfie ngắn.',
  'identity.step3': 'Cho phép truy cập camera khi trình duyệt hỏi — không có nó thì không kiểm tra được.',
  'identity.starting': 'Đang mở…',
  'identity.start': 'Bắt đầu xác minh',
  'identity.partnerNote': 'Bạn sẽ được chuyển đến đối tác xác minh của chúng tôi và quay lại đây ngay.',
  'identity.inProgress': 'Bạn đã bắt đầu. Tiếp tục sẽ nối tiếp từ chỗ bạn dừng.',
  'webview.title': 'Mở trang này trong trình duyệt của bạn',
  'webview.cameraWarn': 'Camera thường không hoạt động trong {browser}, và xác minh danh tính cần đến nó.',
  'webview.namedBrowser': 'trình duyệt tích hợp của {app}',
  'webview.thisBrowser': 'trình duyệt tích hợp của ứng dụng này',
  'webview.iosInstruction': 'Chạm biểu tượng chia sẻ, rồi chọn Open in Safari.',
  'webview.openInChrome': 'Mở trong Chrome',
  'webview.androidInstruction': 'hoặc dùng menu và chọn Open in browser.',
  'webview.otherInstruction': 'Sao chép địa chỉ trang này vào trình duyệt thường của bạn.',

  'confirm.title': 'Xác nhận thông tin của bạn',
  'confirm.subtitle':
    'Chúng tôi đã điền sẵn từ giấy tờ của bạn — kiểm tra tính chính xác và sửa những gì chưa đúng.',
  'confirm.saveFailedTitle': 'Không thể lưu thông tin của bạn',
  'confirm.idOutstandingTitle': 'Chúng tôi vẫn cần giấy tờ tùy thân của bạn',
  'confirm.idOutstandingBody':
    'Việc xác minh danh tính của bạn chưa hoàn tất, vui lòng nhập thông tin bên dưới. Cứ tiếp tục và hoàn tất — chúng tôi sẽ gửi email về giấy tờ.',
  'confirm.firstName': 'Tên',
  'confirm.lastName': 'Họ',
  'confirm.dob': 'Ngày sinh',
  'confirm.whereLive': 'Bạn sống ở đâu?',
  'confirm.city': 'Thành phố',
  'confirm.state': 'Tỉnh / Bang',
  'confirm.saving': 'Đang lưu…',

  'compliance.stillCheckingTitle': 'Chúng tôi vẫn đang kiểm tra giấy tờ của bạn',
  'compliance.backToVerification': 'Quay lại xác minh',
  'compliance.loading': 'Đang tải bảng câu hỏi của bạn…',
  'compliance.loadFailedTitle': 'Chúng tôi không thể tải bảng câu hỏi',
  'compliance.stillStuck': 'Vẫn gặp trục trặc?',
  'compliance.title': 'Một vài câu hỏi cuối',
  'compliance.subtitle':
    'Quy định yêu cầu chúng tôi hỏi những câu này trước khi mở tài khoản. Câu trả lời được lưu cùng hồ sơ của bạn.',
  'compliance.submitting': 'Đang gửi…',
  'compliance.submit': 'Gửi',
  'compliance.oneQuestionLeft': 'Còn 1 câu hỏi cần trả lời.',
  'compliance.questionsLeft': 'Còn {count} câu hỏi cần trả lời.',
  'compliance.saveAnswersFailed': 'Chúng tôi không thể lưu câu trả lời của bạn',

  'gate.stepToFinishTitle': 'Có một bước cần hoàn tất trước',
  'gate.continueWhereLeft': 'Tiếp tục từ chỗ bạn dừng',

  'done.loadingDocs': 'Đang tải vài tài liệu cuối cùng…',
  'done.loadFailedTitle': 'Chúng tôi không thể tải tài liệu của bạn',
  'done.tryAgainMoment': 'Vui lòng thử lại sau giây lát.',
  'done.title': 'Điều cuối cùng',
  'done.readyToSubmit': 'Hồ sơ của bạn đã sẵn sàng để gửi.',
  'done.pleaseAccept': 'Vui lòng đọc và chấp nhận những tài liệu này trước khi chúng tôi mở tài khoản.',
  'done.agreeAll': 'Tôi đã đọc và đồng ý với tất cả {count} tài liệu',
  'done.hideDocs': 'Ẩn tài liệu',
  'done.showDocs': 'Hiển thị {count} tài liệu',
  'done.version': 'Phiên bản {version}',
  'done.finishing': 'Đang hoàn tất…',
  'done.finishSignIn': 'Hoàn tất và đăng nhập',
  'done.oneLeft': 'Còn 1 tài liệu cần bạn chấp nhận.',
  'done.docsLeft': 'Còn {count} tài liệu cần bạn chấp nhận.',
  'done.straightIn': 'Chúng tôi sẽ đưa bạn thẳng vào tài khoản — không cần đăng nhập lại.',
  'done.completeFailed': 'Chúng tôi không thể hoàn tất hồ sơ của bạn',
  'done.acceptEvery': 'Vui lòng chấp nhận mọi tài liệu',
  'done.getApps': 'Tải ứng dụng giao dịch',
  'done.getAppsSubtitle': 'Bạn sẽ giao dịch qua MT5 hoặc ứng dụng KCM Trade khi tài khoản được mở.',
  'done.onComputer': 'Đang dùng máy tính?',
  'done.scanQr': 'Quét mã QR',
  'done.scanQrSuffix': 'để tải ứng dụng trên điện thoại của bạn.',

  'kyc.approvedTitle': 'Đã xác nhận danh tính',
  'kyc.approvedBody': 'Cảm ơn — phần khó nhất đã xong.',
  'kyc.reviewTitle': 'Chúng tôi đang xem xét tài liệu của bạn',
  'kyc.reviewBody':
    'Một nhân viên đang kiểm tra — thường trong vài giờ, và chúng tôi sẽ gửi email cho bạn ngay khi xong. Không cần chờ ở đây: cứ tiếp tục hoàn tất phần còn lại.',
  'kyc.questions': 'Có câu hỏi?',
  'kyc.declinedTitle': 'Chúng tôi không thể xác minh danh tính của bạn',
  'kyc.contactPrefix': 'Liên hệ',
  'kyc.contactSuffix': 'và chúng tôi sẽ xử lý tiếp.',
  'kyc.expiredTitle': 'Phiên đã hết thời gian',
  'kyc.expiredBody':
    'Các phiên xác minh không mở lâu. Bắt đầu lại chỉ mất vài phút.',
  'kyc.continueAnyway': 'Tiếp tục hồ sơ của bạn',
  'kyc.finishLaterBody':
    'Bạn có thể hoàn tất phần còn lại của hồ sơ ngay bây giờ. Chúng tôi sẽ gửi email riêng về giấy tờ tùy thân của bạn, và tài khoản sẽ ở trạng thái chờ cho đến khi việc này hoàn tất.',
  'decline.document_unreadable':
    'Ảnh giấy tờ của bạn không đủ rõ để đọc. Ánh sáng tốt hơn và bề mặt phẳng thường khắc phục được.',
  'decline.face_mismatch': 'Ảnh selfie không khớp với ảnh trên giấy tờ.',
  'decline.document_expired': 'Giấy tờ bạn dùng đã hết hạn.',
  'decline.other': 'Các kiểm tra tự động không thể xác nhận danh tính của bạn.',

  'verify.checkFailedTitle': 'Chúng tôi không thể kiểm tra trạng thái của bạn',
  'verify.checkFailedBody': 'Xác minh của bạn đã được gửi. Làm mới trang này thường sẽ ổn.',
  'verify.refresh': 'Làm mới',
  'verify.stillProcessingTitle': 'Vẫn đang xử lý',
  'verify.stillProcessingBody':
    'Việc này lâu hơn thường lệ. Tài liệu của bạn đã được gửi và không mất gì — chúng tôi sẽ gửi email ngay khi có kết quả.',
  'verify.back': 'Quay lại',
  'verify.checkingTitle': 'Đang kiểm tra tài liệu của bạn',
  'verify.checkingBody': 'Việc này thường mất vài giây. Vui lòng đừng đóng trang này.',
  'verify.checkingAria': 'Đang kiểm tra xác minh của bạn',
  'handoff.receivedTitle': 'Đã nhận tài liệu',
  'handoff.receivedBody': 'Cảm ơn — đó là tất cả những gì chúng tôi cần từ điện thoại của bạn.',
  'handoff.goBackTitle': 'Giờ hãy quay lại máy tính của bạn',
  'handoff.goBackBody':
    'Hồ sơ của bạn vẫn mở trong trình duyệt bạn đã bắt đầu. Hãy hoàn tất ở đó — trang sẽ tự chuyển tiếp khi kiểm tra xong.',
  'handoff.closeTab': 'Bạn có thể đóng tab này.',
  'handoff.somethingWrong': 'Có gì đó không ổn?',
}
